<div class="lead-page" *ngIf="lead">
  <div class="lead-shell">
    <div class="lead-header">
      <div class="lead-title">
        <h2>{{ lead.customer_name }}</h2>
        <p>{{ lead.lead_id }} · <span class="lead-status {{ lead.status }}">{{ lead.status_label }}</span></p>
      </div>
      <div class="lead-actions">
        <button class="action-button bt-edit" (click)="openEditLead()" title="Edit Lead" aria-label="Edit Lead">
          <fa-icon [icon]="['fas', 'pen']"></fa-icon>
        </button>
        <button class="lead-btn-secondary" *ngIf="!lead.sales_installation_partner" (click)="convertToSalesInstallationPartner()">Convert to Sales & Installation Partner</button>
          <button class="lead-btn-secondary" *ngIf="lead.sales_installation_partner" (click)="openRevertFromPartner()">
              Revert to Lead Listing
          </button>
        <button class="lead-btn-muted" (click)="openAddFollowUp()">Add Follow-up</button>
        <button class="lead-btn" (click)="openAddDemo()">Schedule Demo</button>
        <button class="action-button bt-delete" (click)="openDeleteLeadModal()" title="Delete Lead" aria-label="Delete Lead">
          <fa-icon [icon]="['fas', 'trash']"></fa-icon>
        </button>
      </div>
    </div>

    <div class="lead-section">
      <h4>Lead Summary Card</h4>
      <div class="lead-summary-grid">
        <div class="lead-summary-item"><label>Assigned To</label>
          <div>{{ lead.assigned_to_detail?.full_name || 'Unassigned' }}</div>
        </div>
        <div class="lead-summary-item"><label>Next Follow-up Date</label>
          <div>{{ lead.next_follow_up_date || '-' }}</div>
        </div>
        <div class="lead-summary-item"><label>Expected Closure Date</label>
          <div>{{ lead.expected_closure_date || '-' }}</div>
        </div>
        <div class="lead-summary-item"><label>Lead Source</label>
          <div>{{ lead.source_label }}</div>
        </div>
        <div class="lead-summary-item" *ngIf="lead.sales_installation_partner_name"><label>Partner</label>
          <div>{{ lead.sales_installation_partner_name }}</div>
        </div>
      </div>
    </div>

    <div class="lead-section">
      <h4>Customer / Contact Details</h4>
      <div class="lead-summary-grid">
        <div class="lead-summary-item"><label>Contact Person</label>
          <div>{{ lead.contact_person || '-' }}</div>
        </div>
        <div class="lead-summary-item"><label>Phone Number</label>
          <div>{{ lead.phone_number }}</div>
        </div>
        <div class="lead-summary-item"><label>Email</label>
          <div>{{ lead.email || '-' }}</div>
        </div>
        <div class="lead-summary-item"><label>WhatsApp Number</label>
          <div>{{ lead.whatsapp_number || '-' }}</div>
        </div>
        <div class="lead-summary-item"><label>City</label>
          <div>{{ lead.city || '-' }}</div>
        </div>
        <div class="lead-summary-item"><label>State</label>
          <div>{{ lead.state || '-' }}</div>
        </div>
        <div class="lead-summary-item" style="grid-column: 1 / -1;"><label>Address</label>
          <div>{{ lead.address || '-' }}</div>
        </div>
      </div>
    </div>

    <div class="lead-section">
      <h4>ANPR Requirement Details</h4>
      <div class="lead-summary-grid">
        <div class="lead-summary-item"><label>Company Type</label>
          <div>{{ lead.company_type_label || '-' }}</div>
        </div>
        <div class="lead-summary-item"><label>Entry Gates</label>
          <div>{{ lead.entry_gates }}</div>
        </div>
        <div class="lead-summary-item"><label>Exit Gates</label>
          <div>{{ lead.exit_gates }}</div>
        </div>
        <div class="lead-summary-item"><label>Approx Vehicle Count</label>
          <div>{{ lead.approx_vehicle_count || '-' }}</div>
        </div>
        <div class="lead-summary-item"><label>Existing System</label>
          <div>{{ lead.existing_system_label }}</div>
        </div>
        <div class="lead-summary-item" style="grid-column: 1 / -1;"><label>Requirement Summary</label>
          <div>{{ lead.requirement_summary || '-' }}</div>
        </div>
      </div>
    </div>

    <div class="lead-section">
      <h4>Timeline / Activity</h4>
        <app-activity-timeline [activities]="lead.activities || []"></app-activity-timeline>
    </div>

    <div class="lead-section">
      <h4>Follow-ups</h4>
      <div class="lead-table-wrap">
        <table class="lead-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Date</th>
              <th>Next Follow-up</th>
              <th>Notes</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!lead.follow_ups.length">
              <td colspan="5" class="lead-empty">No follow-ups added yet.</td>
            </tr>
            <tr *ngFor="let followUp of lead.follow_ups">
              <td>{{ followUp.follow_up_type }}</td>
              <td>{{ followUp.follow_up_date }}</td>
              <td>{{ followUp.next_follow_up_date || '-' }}</td>
              <td>{{ followUp.notes || '-' }}</td>
              <td class="table-actions-cell">
                <div class="table-actions">
                  <button class="action-button bt-edit" (click)="openEditFollowUp(followUp)" title="Edit Follow-up"
                    aria-label="Edit Follow-up">
                    <fa-icon [icon]="['fas', 'pen']"></fa-icon>
                  </button>
                  <button class="action-button bt-delete" (click)="deleteFollowUp(followUp)" title="Delete Follow-up"
                    aria-label="Delete Follow-up">
                    <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="lead-section">
      <h4>Demo Details</h4>
      <div class="lead-table-wrap">
        <table class="lead-table">
          <thead>
            <tr>
              <th>Date & Time</th>
              <th>Type</th>
              <th>Status</th>
              <th>Notes</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!lead.demos.length">
              <td colspan="5" class="lead-empty">No demos scheduled yet.</td>
            </tr>
            <tr *ngFor="let demo of lead.demos">
              <td>{{ demo.demo_datetime | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ demo.demo_type }}</td>
              <td><span class="lead-status {{ demo.demo_status }}">{{ demo.demo_status }}</span></td>
              <td>{{ demo.demo_notes || '-' }}</td>
              <td class="table-actions-cell">
                <div class="table-actions">
                  <button class="action-button bt-edit" (click)="openEditDemo(demo)" title="Edit Demo"
                    aria-label="Edit Demo">
                    <fa-icon [icon]="['fas', 'pen']"></fa-icon>
                  </button>
                  <button class="action-button bt-delete" (click)="deleteDemo(demo)" title="Delete Demo"
                    aria-label="Delete Demo">
                    <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="lead-modal-backdrop" *ngIf="showFollowUpModal">
  <div class="lead-modal">
    <div class="lead-title">
      <h3>{{ editingFollowUp ? 'Edit Follow-up' : 'Add Follow-up' }}</h3>
    </div>
    <div class="lead-form-grid">
      <div class="lead-form-field">
        <label>Follow-up Type</label>
        <select [(ngModel)]="followUpForm.follow_up_type">
          <option *ngFor="let type of followUpTypes" [value]="type[0]">{{ type[1] }}</option>
        </select>
      </div>
      <div class="lead-form-field">
        <label>Follow-up Date</label>
        <p-datepicker 
          [(ngModel)]="followUpForm.follow_up_date" 
          dateFormat="dd/mm/yy" 
          [showIcon]="true"
          inputId="lead-detail-follow-up-date"
          [showOnFocus]="true" 
          [showButtonBar]="true" 
          [readonlyInput]="true">
        </p-datepicker>
      </div>
      <div class="lead-form-field">
        <label>Next Follow-up Date</label>
        <p-datepicker 
        [(ngModel)]="followUpForm.next_follow_up_date" 
        dateFormat="dd/mm/yy" 
        [showIcon]="true"
        inputId="lead-detail-next-follow-up-date" 
        [showOnFocus]="true" 
        [showButtonBar]="true" [
        readonlyInput]="true">
        </p-datepicker>
      </div>
      <div class="lead-form-field" style="grid-column: 1 / -1;">
        <label>Notes</label>
        <textarea [(ngModel)]="followUpForm.notes"></textarea>
      </div>
    </div>
    <div class="inline-actions">
      <button class="lead-btn" (click)="addFollowUp()">{{ editingFollowUp ? 'Update Follow-up' : 'Save Follow-up'
        }}</button>
      <button class="lead-btn-muted" (click)="showFollowUpModal = false; editingFollowUp = null">Cancel</button>
    </div>
  </div>
</div>

<div class="lead-modal-backdrop" *ngIf="showDemoModal">
  <div class="lead-modal">
    <div class="lead-title">
      <h3>{{ editingDemo ? 'Edit Demo' : 'Schedule Demo' }}</h3>
    </div>
    <div class="lead-form-grid">
      <div class="lead-form-field">
        <label>Demo Date & Time</label>
        <p-datepicker 
        [(ngModel)]="demoForm.demo_datetime"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        inputId="lead-detail-demo-datetime" 
        [showOnFocus]="true" 
        [showButtonBar]="true" 
        [readonlyInput]="true"
        [showTime]="true" 
        hourFormat="24"
          >
        </p-datepicker>
      </div>
      <div class="lead-form-field">
        <label>Demo Type</label>
        <select [(ngModel)]="demoForm.demo_type">
          <option *ngFor="let type of demoTypes" [value]="type[0]">{{ type[1] }}</option>
        </select>
      </div>
      <div class="lead-form-field">
        <label>Demo Status</label>
        <select [(ngModel)]="demoForm.demo_status">
          <option *ngFor="let status of demoStatuses" [value]="status[0]">{{ status[1] }}</option>
        </select>
      </div>
      <div class="lead-form-field" style="grid-column: 1 / -1;">
        <label>Demo Notes</label>
        <textarea [(ngModel)]="demoForm.demo_notes"></textarea>
      </div>
      <!-- <div class="lead-form-field">
        <label>
          <input type="checkbox" [(ngModel)]="demoForm.remind_one_hour_before" />
          Remind 1 hour before demo
        </label>
      </div> -->
      <div class="check">
        <input type="checkbox" [(ngModel)]="demoForm.remind_one_hour_before" />
        Remind 1 hour before demo
      </div>
    </div>
    <div class="inline-actions">
      <button class="lead-btn" (click)="addDemo()">{{ editingDemo ? 'Update Demo' : 'Save Demo' }}</button>
      <button class="lead-btn-muted" (click)="showDemoModal = false; editingDemo = null">Cancel</button>
    </div>
  </div>
</div>

<div class="lead-modal-backdrop" *ngIf="showConvertPartnerModal">
  <div class="lead-modal">
    <div class="lead-title">
      <h3>Convert Partner</h3>
      <p>Are you sure you want to convert this lead to a Sales & Installation Partner?</p>
    </div>
    <div class="inline-actions">
      <button class="lead-btn-muted" (click)="showConvertPartnerModal = false">Cancel</button>
      <button class="lead-btn" (click)="confirmConvertToSalesInstallationPartner()">Convert</button>
    </div>
  </div>
</div>

<div class="lead-modal-backdrop" *ngIf="showRevertPartnerModal">
    <div class="lead-modal">
        <div class="lead-title">
            <h3>Revert to Lead Listing</h3>
            <p>Unlink this lead from the Sales & Installation Partner and show it again in the lead list?</p>
        </div>
        <div class="inline-actions">
            <button class="lead-btn-muted" (click)="showRevertPartnerModal = false" [disabled]="revertingPartner">
                Cancel
            </button>
            <button class="lead-btn" (click)="confirmRevertFromPartner()" [disabled]="revertingPartner">
                {{ revertingPartner ? 'Reverting...' : 'Revert' }}
            </button>
        </div>
    </div>
</div>

<div class="lead-modal-backdrop" *ngIf="showDeleteLeadModal">
  <div class="lead-modal">
    <div class="lead-title">
      <h3>Delete Lead</h3>
      <p>Delete lead {{ lead.lead_id || lead.customer_name }}?</p>
    </div>
    <div class="inline-actions">
      <button class="lead-btn-muted" (click)="closeDeleteLeadModal()" [disabled]="deletingLead">Cancel</button>
      <button class="lead-btn-danger" (click)="confirmDeleteLead()" [disabled]="deletingLead">
        {{ deletingLead ? 'Deleting...' : 'Delete' }}
      </button>
    </div>
  </div>
</div>
